module.exports = __webpack_public_path__ + "img/effects-10.8f966609.png";